import React from 'react';
import Check from '../../assets/images/check.svg';
import Clear from '../../assets/images/clear.svg';
import { textBodySmall } from '../../styles/typography';
import { classNames } from '../../utils/style';
import { getEnvUrl } from '../Picto/logic';
import { Popover } from '../Popover';

export interface PricingCardsFeatureProps {
  /** The feature name */
  name: React.ReactNode;
  /** Whether the feature is included in the plan */
  included?: boolean;
  /** Optional tooltip text to show more information */
  tooltipText?: React.ReactNode;
  /** Optional tooltip title */
  tooltipTitle?: string;
}

/**
 * Feature component used in pricing cards to display whether a feature
 * is included or not, with optional tooltip for more information.
 */
export const Feature = ({
  included = true,
  tooltipText,
  tooltipTitle,
}: PricingCardsFeatureProps) => {
  const Icon = included ? Check : Clear;

  return (
    <div
      className={classNames(
        'Feature',
        'flex flex-row items-center justify-between',
        included && 'included',
      )}
    >
      <div className="flex items-start gap-12">
        <div className="Feature__pictobox h-[27px] w-16" aria-hidden="true">
          <div className="w-18 relative top-[3px] w-full object-contain">
            <Icon
              className={classNames(
                included ? 'check' : 'clear',
                'h-full w-full',
              )}
            />
          </div>
        </div>
        <div
          className={classNames(
            textBodySmall,
            'flex flex-1 items-baseline',
            included ? 'text-neutral-301' : 'text-silver-300',
          )}
        >
          {tooltipText ? (
            <Popover
              label={
                <div>
                  {tooltipTitle}
                  <img
                    src={`${getEnvUrl()}/icon/info_outline_grey.svg`}
                    alt=""
                    width={14}
                    height={14}
                    className="mb-4 ml-8 inline-block h-[15px] w-[15px]"
                  />
                </div>
              }
              className="w-full"
            >
              <div className="md:w-[280px]">
                <div className="pb-8 font-sans text-16 leading-22">
                  {tooltipTitle}
                </div>
                <div className="pb-8 font-sans text-12 leading-16">
                  {tooltipText}
                </div>
              </div>
            </Popover>
          ) : (
            tooltipTitle
          )}
        </div>
      </div>
    </div>
  );
};
